import React from 'react'

import ViewsControl from 'themes/common/components/controls/ViewsControl'

import './DisplayerBottomSection.scss'

interface DisplayerBottomSectionProps {
  views: number
  view: number
  changeView: (view: number) => void
}

const DisplayerBottomSection = ({ views, view, changeView }: DisplayerBottomSectionProps) => {
  return (
    <div className="displayer-bottom-section displayer-bottom-section--touch">
      {views > 1 && <ViewsControl views={views} view={view} changeView={changeView} />}
    </div>
  )
}

export default DisplayerBottomSection
